export default __webpack_public_path__ + "static/media/actionBox.10de7f4c.svg";